import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss'],
})
export class ManagementComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
    private translate: TranslateService
  ) {}
  public arrayPath: string[] = [];

  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      this.meta.addTag({
        name: 'description',
        content: '',
      });
      this.title.setTitle('日本医薬品 | 経営情報');
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.meta.addTag({
        name: 'description',
        content:
          'Mission Statement | Japan Pharma Inc. strives to improve the health and development of society through responsible,',
      });
      this.title.setTitle('JAPAN PHARMA INC. | management');
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }
}
